import { createFileRoute } from "@tanstack/react-router"
import { ExtractUploadPage } from "@/features/schema-management/pages/ExtractUploadPage"

function ExtractUploadPageWrapper() {
    const { documentTypeId } = Route.useParams()
    return <ExtractUploadPage documentTypeId={parseInt(documentTypeId)} />
}

export const Route = createFileRoute("/_authenticated/agent/document/extract/$documentTypeId/")({
    component: ExtractUploadPageWrapper,
})
